import { configureStore } from '@reduxjs/toolkit';
import { checkLogin } from './auth/auth-actions';
import authSlice from './auth/auth-slice';
import translateSlice from './translate/translate-slice';
import contestSlice from './contest/contestSlice';
import scoreboardSlice from './scoreboard/scoreboardSlice';

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        translate: translateSlice.reducer,
        contest: contestSlice.reducer,
        scoreboard: scoreboardSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

store.dispatch(checkLogin());
export default store;
